export default __webpack_public_path__ + "static/media/ArialMdm.a187e584.ttf";